import { isIframe } from "../../core/common/Common";
import { API_ENDPOINT, apiCaching, GET } from "./_base.api";

export const getToken = async (siteUUID = '') => {
    if (!isIframe()) {
        return;
    }
    if (apiCaching.has(siteUUID)) {
        return apiCaching.get(siteUUID);
    }

    const url = `${API_ENDPOINT}/get-token?uuid=${siteUUID}`;
    const json = await GET(url, { includeAuth: false });
    apiCaching.set(siteUUID, json);
    return json;
}